module.exports = __webpack_public_path__ + "fff4db59ed6d35a0adb0019e8050d389.png";